export const hudAssets = {
	ribbon: "/spec_hud/ribbon.png",
	dotInactive: "/spec_hud/dot-inactive.png",
	dotActive: "/spec_hud/dot-active.png",
	background: "/spec_hud/background.png"
} as const;
